<template>
  <div v-if="periodItem.id" class="check-form">
    <new-header :title="form.name" @back="back"></new-header>
    <a-row :gutter="20" >
      <a-col :span="5" class="panel-left">
        <div class="patient-info">
          <div class="patient-info-name">
            {{patient.patientNum}}/{{patient.name}}
          </div>
          <div v-if="patient.teleType1" >
            {{patient.teleType1}}：{{patient.telephone1}}
          </div>
          <div v-else>
            -
          </div>
          <div v-if="patient.teleType2">
            {{patient.teleType2}}：{{patient.telephone2}}
          </div>
          <div v-if="patient.teleType3">
            {{patient.teleType3}}：{{patient.telephone3}}
          </div>
        </div>
        <!--<div class="header-info">-->
          <!--<label class="label">待关闭质疑数：</label>{{form.questionCount}}-->
        <!--</div>-->
        <!--<div class="header-info">-->
          <!--<label class="label">提交人：</label>{{form.userRealname}}-->
        <!--</div>-->
        <!--<div class="header-info">-->
          <!--<label class="label">提交时间：</label>{{form.submitTime}}-->
        <!--</div>-->
        <a-divider />
        <a-row class="form-info">
          <a-col :span="10" class="form-info-label">
            研究者：
          </a-col>
          <a-col :span="14" class="form-info-value">
            {{form.personName}}
          </a-col>
        </a-row>
        <a-row class="form-info">
          <a-col :span="10" class="form-info-label">
            提交人：
          </a-col>
          <a-col :span="14" class="form-info-value">
            {{form.userRealname || '-'}}
          </a-col>
        </a-row>
        <a-row class="form-info">
          <a-col :span="10" class="form-info-label">
            提交时间：
          </a-col>
          <a-col :span="14" class="form-info-value">
            {{form.submitTime || '-'}}
          </a-col>
        </a-row>
        <a-row class="form-info">
          <a-col :span="10" class="form-info-label">
            最近更新：
          </a-col>
          <a-col :span="14" class="form-info-value">
            {{form.updateTime || '-'}}
          </a-col>
        </a-row>
        <a-divider />
        <div class="form-status">
          <div class="title">
            最近更新时间
          </div>
          <div class="value">
            {{latelyTime}}
          </div>
        </div>
        <div class="form-status">
          <div class="title">
            当前待关闭质疑数
          </div>
          <div class="value">
            {{form.questionCount}}
          </div>
        </div>
        <div class="form-status">
          <div class="title">
            历史总质疑数
          </div>
          <div class="value">
            {{form.questionAllCount}}
          </div>
        </div>
        <div class="form-status">
          <div class="title">
            修改次数
          </div>
          <div class="value">
            {{opEditCount}}
          </div>
        </div>
        <a-divider />
        <div style="text-align: center;">
          <a-button v-has="'checkdata:batchCloseQuestion'"  v-if="questionList.length>0" @click="closeQuestionListHandle">
          批量关闭质疑
          </a-button>
        </div>
      </a-col>
      <a-col :span="19" class="panel panel-right">
        <div class="header-title">
          <div style="float: right">
            <a-button size="small" @click="baseDataView">
              原始数据
            </a-button>
          </div>
        </div>
        <form-view v-if="form.id" :questionList="questionList" ref="formView" :show-tip-btn="true" :base-data="form" :readOnly="true">
        </form-view>

      </a-col>
      <!--<a-col :span="7" class="panel">-->

      <!--</a-col>-->
    </a-row>
    <a-drawer
      title="原始数据"
      :width="'80%'"
      :visible="baseDataVisible"
      :closable="true"
      @close="handleBaseDataCancel">
      <div class="center-panel base-file-title">
      原始数据
      </div>
      <recording :showRecorder="false" :patientName="patient.name" :formId="form.id" :formName="form.name" :projectId="patient.projectId" :patientId="patient.id"></recording>

    </a-drawer>
    <a-modal
      title="批量关闭质疑"
      width="80%"
      :visible="closeQuestionListVisible"
      :confirmLoading="loading"
      @ok="handleCloseQuestionListSubmit"
      @cancel="handleCloseQuestionListCancel">
      <a-row style="margin-bottom: 20px">
        <a-col :span="4" style="text-align: right">关闭理由：</a-col>
        <a-col :span="18">
          <div style="margin-bottom: 10px">
            <a-radio-group buttonStyle="solid" v-model="questionForm.handleInfo">
              <a-radio value="已修改">已修改</a-radio>
              <a-radio value="无需修改">无需修改</a-radio>
              <a-radio value="-1">其他</a-radio>
            </a-radio-group>
          </div>
          <div v-if="questionForm.handleInfo==='-1'">
            <a-textarea :rows="2"  placeholder="请输入" v-model="questionForm.description" />
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="4" style="text-align: right">质疑元素：</a-col>
        <a-col :span="18">
          <a-table
            size="small"
            bordered
            rowKey="id"
            :columns="questionColumns"
            :dataSource="questionList"
            :pagination="false"
            :rowSelection="{selectedRowKeys:questionSelectedRowKeys, onChange: onQuestionSelectChange, type: 'checkbox'}"
            :loading="loading"
            >
          </a-table>
        </a-col>
      </a-row>
    </a-modal>
  </div>
  <a-empty
    v-else
  >
    <span slot="description"> 正在加载数据</span>

  </a-empty>
</template>

<script>
  import { getAction,postAction } from '@/api/manage'
  import FormView from '@/views/project/components/FormView'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import Recording from '@/views/project/patient/components/recording/Index'
  import NewHeader from '@comp/pad/NewHeader'
  export default {
    name: 'CheckForm',
    components: { ATextarea, FormView ,Recording,NewHeader},
    provide(){
      return{
        parentLoadData:this.loadData,
      }
    },
    data(){
      return {
        key:[],
        form:{},
        patient:{},
        periodItem:{},
        opList:[],
        questionList:[],
        loading:false,
        closeQuestionListVisible: false,
        questionSelectedRowKeys:[],
        questionForm:{
          handleInfo:'',
          description:''
        },
        questionColumns:[
          {
            title: '元素名称',
            align: "center",
            dataIndex: 'formItemName',
            width: 200
          },
          {
            title: '相关质疑',
            align: "center",
            dataIndex: 'description',
            width: 200
          },
        ],
        baseDataVisible:false,
      }
    },
    computed:{
      opEditCount(){
        let count = 0
        this.opList.forEach(item=>{
          if('3' === item.type){
            count++;
          }
        })
        return count
      },
      latelyTime(){
        let result = '-'
        // 因为有可能是系统质疑，没有操作记录。所以默认是系统质疑时间
        if(this.questionList && this.questionList.length>0){
          result = this.questionList[0].createTime
        }
        let newOp = null
        //获取操作时间
        this.opList.forEach(item=>{
          if('3' === item.type || '4' === item.type||'5' === item.type || '6' === item.type){
            if(newOp===null){
              newOp = item
            }
          }
        })
        if(newOp!=null){
          result=newOp.createTime
        }
        return result
      }
    },
    mounted() {
      this.loadData()
    },
    methods:{
      loadData(){
        const patientFormId = this.$route.params.id
        getAction('/patient/patient/getFormViewInfo',{patientFormId:patientFormId}).then(res=>{
          if(res.success){
            //加载患者信息，
            //加载所在周期信息
            //加载周期的表单信息
            //加载表单信息
            this.form = res.result.form
            this.periodItem = res.result.periodItem
            this.patient = res.result.patient
            this.loadQuestionList();
          }
        })
        getAction('/patient/patientFormItemOp/list',{formId:patientFormId}).then(res=>{
          if(res.success){
            this.opList = res.result
          }
        })
      },
      loadQuestionList(){
        this.loading = true
        //获取当前表单的质疑记录
        getAction('/question/patientQuestion/listAll',{projectId:this.form.projectId,status:'1',formId:this.form.id}).then(res=>{
          if(res.success){
            this.questionList = res.result
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      closeQuestionListHandle(e){
        // 阻止事件冒泡
        e.stopPropagation()
        this.closeQuestionListVisible = true
      },
      handleCloseQuestionListSubmit(){
        if(this.questionSelectedRowKeys.length===0){
          return this.$message.warning('请选择质疑元素')
        }
        if(!this.questionForm.handleInfo){
          return this.$message.warning('请选择关闭理由')
        }
        const params = {
          idList:this.questionSelectedRowKeys,
          projectId:this.form.projectId
        }
        if(this.questionForm.handleInfo==='-1'){
          if(!this.questionForm.description){
            return this.$message.warning('请输入“其他”关闭理由')
          }else{
            params.description = this.questionForm.description
          }
        }else{
          params.description = this.questionForm.handleInfo
        }
        postAction('/question/patientQuestion/closeList',params).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.loadQuestionList();
            this.handleCloseQuestionListCancel()
          }
        })
      },
      handleCloseQuestionListCancel(){
        this.closeQuestionListVisible = false
      },
      onQuestionSelectChange(selectedRowKeys, selectedRows) {
        this.questionSelectedRowKeys = selectedRowKeys;
      },
      handleBaseDataCancel(){
        this.baseDataVisible = false
      },
      baseDataView(){
        this.baseDataVisible = true
      }
    }
  }
</script>

<style scoped lang="less">
  .check-form{
    // padding: 10px;
  }
  .header-title{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin: 10px;
    overflow: hidden;
  }

  .panel-right{
    height: calc(100vh - 41px);
    overflow-y: auto;
    background-color: #f0f2f5;
  }
  .panel-left{
    overflow-y: auto;
    height: calc(100vh - 41px);
    background-color: white;
    /deep/ .ant-divider-horizontal{
      margin: 12px 0;
    }
    .patient-info{
      margin-top: 5px;
      border: 1px solid #9292CB;
      background-color: #CEEBEC;
      border-radius: 5px;
      padding: 5px;
      .patient-info-name{
      }

    }
    .form-info{
      .form-info-label{
        text-align: right;
      }
      .form-info-value{
        text-align: left;
      }
    }
    .form-status{
      text-align: center;
      .title{
        font-weight: bold;
      }
      .value{
        font-weight: bold;
      }
    }
  }
</style>
<style lang="less">
  .check-form{
  }
</style>